import React, { Component, useState } from "react";
import "./App.css";
import { Link, Redirect, useHistory, useLocation } from "react-router-dom";
import Axios from "axios";
import ReactTooltip from "react-tooltip";
import QrReader from "react-qr-scanner";
import Footer from "./components/Footer";
import {
  IoIosRemoveCircleOutline,
  IoIosCheckmarkCircleOutline,
  IoLogoAndroid,
  IoLogoWindows,
  IoLogoChrome,
  IoLogoApple,
  IoIosBrowsers,
  IoIosSettings,
  IoIosArrowBack,
} from "react-icons/io";
import { BiEditAlt, BiRefresh } from "react-icons/bi";
import { AiOutlineScan } from "react-icons/ai";
import { RiCalendarEventLine } from "react-icons/ri";
import { FaEdge, FaSafari, FaFirefox, FaLinux } from "react-icons/fa";

// import Header from "./components/HeaderCampaign";
import Switch from "react-switch";
// import HorizontalScroller from "react-horizontal-scroll-container";
import TopBarProgress from "react-topbar-progress-indicator";
import { Col, Container, Row } from "react-bootstrap";
import Summary from "./components/payouts/Summary";
import PayoutRequestList from "./components/payouts/PayoutRequestList";
import Breakdown from "./components/payouts/Breakdown";
import Header3 from "./components/Header3";
import Header from "./layouts/Header";

// const { state } = this.props.location || {};
// const event_id = state?.eventid;
const Payout = () => {
  const [count, setCount] = useState(0);
  const [refreshing, setRefreshing] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const { eventid, eventname, is_sponsorship } = location.state || {};
  const event_id = eventid;
  const event_name = eventname || "Event Name Not Provided";
  const business_id = localStorage.getItem("businessid");

  const refreshView = () => {
    return (
      <label
        className="refresh-btn"
        title="Refreh"
        data-for="refreshSummary"
        data-tip="Refreh"
        style={{ cursor: "pointer", marginTop: "-10px" }}
        onClick={() => {
          setCount(count + 1);
          setRefreshing(true);
        }}
      >
        {refreshing ? "Updating..." : ""} <BiRefresh size={30} />
        <ReactTooltip
          id="refreshSummary"
          place="top"
          type="dark"
          effect="solid"
          className="p-1"
        />
      </label>
    );
  };

  return (
    <div className="view mt-5">
      <Header />
      <div className="containe pl-1 pr-1">
        <div className="row justify-content-center just-container-insid">
          <div className="col-lg-12 mt-5 mb-4">
            {is_sponsorship == true ? (
              <div
                className="sponsored-badge w-100 p-2 text-center"
                style={{ fontSize: 16 }}
              >
                🌟 Tickets to this event are proudly sponsored by Karamale.
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="col-lg-12">
            {/* <div className="col-12 mb-3">
              <h4>Payout</h4>
            </div> */}
            <div className="col-12 mb-0 text-right">
              <label className="">
                {refreshView()} |
                <span
                  className="cursor-pointer"
                  onClick={() => history.goBack()}
                >
                  <IoIosArrowBack size={25} /> Back
                </span>
              </label>
            </div>
            <div className=" BoxDashboardContainer mb-4 pb-3  pl-3 pr-3 w-100">
              <div className="row justify-content-center w-100">
                <label className="mb-3 text-left w-100">
                  <h5>{event_name}</h5>
                </label>
                <div className="col-12 p-0">
                  <PayoutRequestList
                    eventid={event_id}
                    count={count}
                    setRefreshing={setRefreshing}
                    source={"organiserPayout"}
                  />
                </div>
                <div className="col-12 p-0">
                  <Summary eventid={event_id} count={count} />
                </div>
                <div className="col-12 p-0">
                  <Breakdown eventid={event_id} count={count} />
                </div>
                {/* <div className="col-lg-6 p-1">
                    <Breakdown eventid={event_id} />
                  </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Payout;
